import { API } from '../../../api';
import { axiosInstance } from '../../../utils/fetcher';

export const getLossAndDamageClaimsStatusEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetClaimStatus`,
  });
};

export const getLADRegionListEffect = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.LOSS_AND_DAMAGE}/GetRegion`,
  });
};

export const getLADProcessorListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetClaimProcessor`,
  });
};

export const getClaimCommodityCodeListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetCommodityCode`,
  });
};

export const getClaimLidLabelListEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetLidLabel`,
  });
};
